<template>  
    <div class="containerNcm">   
        <div class="painel2">
        <img src="/arqlef/arqlef2.svg" alt="" />
        </div>
        <!-- Modal Status Sefaz -->
        <b-modal id="modalStatus"  ref="modalStatus" size="lg">
            <p class="txtStatus" style="padding-bottom:12px;border-bottom:1px solid #707070;">Status das notas na SEFAZ</p><br>
            <div style="display:flex;align-items:center;justify-content: center;">
                <div style="margin-right:20px">
                    <p class="txtStatus">Notas baixadas</p>
                    <p  class="txtQu">{{notasBaixadas}}</p>
                </div>
                <div style="margin-left:20px">
                    <p class="txtStatus">Aguardando SEFAZ</p>
                    <p class="txtQu">{{aguardandoSEFAZ}}</p>
                </div>
            </div>
            <div v-if="!spinerStatus">
                <p v-if="msgErroStatus" style="text-align:center;">{{msgErroStatus}}</p>
                <tableStatusEmitir :clickStatus="clickStatus" :tableNotas="listaStatus.lstDocumentos" :exibitable="!msgErroStatus" /> 
            </div>
            <div v-else style="display: flex;justify-content: center;margin-bottom:30px;"> 
                <div class="spinerMedio">

                </div>
            </div>
            <div style="display:flex;align-items:center;justify-content: center;margin-bottom:10px;" v-if="!spinerStatus">
                <button class="btnOk" @click="$refs['modalStatus'].hide()" >Ok</button>            
            </div>
        </b-modal>
        <!-- Fim Modal -->
        <ModalFiltro @thisDoModalFiltro="thisFiltro = $event"/>
        <!-- Modal Consulta Receita -->
        <b-modal id="modalReceita"  ref="modalReceita" >
            <p style="color:#707070;font-weight:bold;font-size:22px;margin-top:20px;">Consultando notas na Receita</p><br>
            <p  v-if="msgNotasAtulizar" v-html="msgNotasAtulizar"></p>
            <div style="display:flex;justify-content:center;">
                <div class="spinerMedio" v-show="mostraSpinerAtulizar">
                </div>
            </div>
            <button @click="atulizarNotas()" v-show="mostraBtnAtulizar" class="btnAtualizar">Atualizar lista</button>            
        </b-modal>
        <!-- Fim Modal -->         
        <p class="alltxtEmpresa">{{$store.state.razaoSocial}}</p>
        <div style="padding: 10px">
            
            <div class="clickarquivo arquivoreceita" :style="{'background': tipoNota == 'NFCe' ? '#cccccc':'', 'cursor': tipoNota == 'NFCe'?'inherit':''}"  @click="consultar('consultar')">
                <p>
                    <img src="/arqlef/img/cloud.svg" alt="" style="width: 26px; margin-right: 10px;"
                    ><span>Importar da Receita</span>
                </p>
            </div>
        </div>
        <div class="allOpcoes">
            <div class="allCad">
                <div @click=" allOpNotas =  !allOpNotas" style="width:100%;">
                    <img class="allAbl" src="/arqlef/setaBaixo.svg" width="15px" style="top:14px;">                
                    <span>
                        Tipo de nota: {{tipoNota}}
                    </span>
                </div>
                <div class="allOpPadrao" v-show="allOpNotas">                   
                    <div class="allAjuste" style="background:#E5F4F3;" @click="nota('NFe')">
                        <p style="font-size:14px;">NFe</p>
                    </div>
                     <div class="allAjuste" @click="nota('NFCe')">
                        <p style="font-size:14px;">NFCe</p>
                    </div>
                    <div class="allAjuste" style="background:#E5F4F3;" @click="nota('CTe')">
                        <p style="font-size:14px;">CTe </p>
                    </div>
                </div>
            </div>
            <div  :class="[{allCad:true} ,{desativado: $store.state.tipoNota == 'CTe' ? true : false}]"  @click="$router.push({name:'importar'})" >
                <div  style="width:100%;" >
                    <img class="allAbl" src="/arqlef/mais.svg"  style="top:14px;" width="13px">                                
                    <span style="margin-left:10px;">
                        Adicionar Notas 
                    </span>
                </div>
            </div>
            <div :class="[{allCad:true} ,{desativado: $store.state.tipoNota == 'NFCe'  ? true : false}]">
                 <div @click="AbrirModalNfe()" style="width:100%;" >
                    <img class="allAbl" src="/arqlef/setaBaixo.svg" width="15px" style="top:14px;">                
                    <span>
                        Exportar
                    </span>
                </div>
                <div class="allOpPadrao" v-show="allOpNotasE">                   
                    <div class="allAjuste" @click="$router.push({name:'baixar'})" style="background:#E5F4F3;">
                        <p style="font-size:14px;">Exportar Notas em XML</p>
                       
                    </div>
                    <div class="allAjuste"  @click="relatorio">
                         <p style="font-size:14px;">Exportar Relatórios</p>
                    </div>
                </div>               
            </div>            
            <div :class="[{allCad:true},{desativado: $store.state.tipoNota == 'NFCe' ? true : false}]" >
                <div style="width:100%;" @click="abrirModal">
                     <img class="allAbl" src="/arqlef/calendario.svg"  style="top:13px;" width="15px">                                
                    <span style="margin-left:10px;">
                        Filtrar
                    </span>
                </div>
            </div>
        </div>      
        <QuantNotas v-if="!spinerMedio && temFiltro "  :qntNota="somatoria" :estado="estado" />  
        <div style="padding-left:10px;padding-right:10px;display: flex;justify-content: flex-end;" v-if="!spinerMedio && temFiltro">
            <p style="font-weight: bold; margin-top: 13px; cursor: pointer;  font-size: 15px;    color: rgb(206, 206, 206);   margin-bottom: 0px;" @click="limpaFiltro()">Limpar filtro</p>
        </div> 
        <div v-if="!spinerMedio" >       
            <OpcoesNotas 
            @valorNota="somatoria = $event"
                @tirarSomataria="temFiltro = $event"
                :existeNota="existeNota" 
                @existeNota="existeNota = $event"
                :notas="notas" 
                :objEnviaNotas="objEnviaNotas" 
                @pegarTag="objEnviaNotas.obj.tag = $event; currentPage = 1"
                @quantTotal="notasQuant = $event"
                @getNotas="notas = $event"
            > </OpcoesNotas>
        </div>
        <div v-else  style="display: flex;justify-content: center;margin-top:100px;">
            <div class="spinerMedio">

            </div>
        </div>
        <br>   
     
        <div style="display: flex;justify-content: center;" v-if="notasQuant >= 70 && existeNota">
            <b-pagination
                v-model="currentPage"
                :total-rows="this.notasQuant"
                per-page="70"
                first-number
                last-number
                @input="myClickedEventhandler(currentPage)"
            ></b-pagination>
        </div>
        <br>
         <b-modal id="modalExportar"  ref="modalExportar" >
             <div v-if="spinerLink" style="display: flex;    align-items: center;    justify-content: center;">
                 <b-spinner label="Loading..."></b-spinner>
             </div>
             <div  v-else>
                 <p style="text-align: center;font-size: 18px;font-weight: 600;" v-if="linkTrue">Erro. Tente novamente daqui alguns minutos</p>
                 <p style="text-align: center;font-size: 18px;font-weight: 600;" v-else><a :href="this.linkEx.data">Clique aqui para baixar</a></p>
             </div>
            
        </b-modal>
        <vue-topprogress ref="topProgress"></vue-topprogress>
    </div>      
</template>

<script>
import OpcoesNotas from '../shared/OpcoesNotas'
import ModalFiltro from '../shared/ModalFiltro'
import tableStatusEmitir from '../components/tableStatusEmitir'
import QuantNotas from '../components/Quantidade.vue'
import config from '../services/config'
import barramento from '../services/barramento'
import { vueTopprogress } from "vue-top-progress";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Mixin from '../services/Mixin'
export default {
    components: { tableStatusEmitir, QuantNotas,ModalFiltro,OpcoesNotas,vueTopprogress },
   mixins:[Mixin],
   data(){
        return{
            estado:'', 
            allOpNotasE:false,
            clickStatus:false,
            notasBaixadas:0,  
            aguardandoSEFAZ:0,          
            perPage: 1,
            existeNota:true,
            currentPage: 1,           
            tipoNota:'NFe',
            setaNota:'/sandboxfront/arqlefsetaBaixo.svg',
            allOpNotas:false,
            allOpConsultar:false,            
            mostraSpinerAtulizar:false,
            mostraBtnAtulizar:false,
            msgNotasAtulizar:'',
            listaStatus:[],
            spinerStatus:false,
            msgErroStatus:'',    
            linkEx:'',      
            linkTrue:'',
            spinerLink:false,                
                  
        }
    },
    methods:{
        AbrirModalNfe(){
            if(this.$store.state.tipoNota != 'NFCe'){
                this.allOpNotasE =  !this.allOpNotasE
            }
        },
        async relatorio(){
            this.$refs['modalExportar'].show()
            this.spinerLink= true
            this.linkEx = await config.getRelatorio(this.$store.state.idEmpresa,this.tipoNota, this.objEnviaNotasNfe)
            console.log(this.linkEx)
            if(this.linkEx.status >=400){
                this.linkTrue = true
                
            }else{
                this.linkTrue = false
                
                //window.open(this.linkEx.data,'_blank')
            }
            this.spinerLink = false
        },
        async limpaFiltro(){
            await this.nota(this.tipoNota)
            this.temFiltro = false            
        },
        abrirModal(){    
            if(this.$store.state.tipoNota != 'NFCe'){     
                this.thisFiltro.show()  
            }
        },
       
        myClickedEventhandler(pag){
            barramento.$emit('getInputMudou',false)
            this.objEnviaNotasNfe.numeroPagina = pag
            this.objEnviaNotasCte.numeroPagina = pag
            this.getNotas()
        },
        async getNotas(){  
                this.existeNota = false
                this.spinerMedio = true
                console.log( "-------------");
                console.log( this.$store.state.opNota);
                console.log( "-------------");
                this.objEnviaNotasNFCe.tag = 2
                if(this.$store.state.opNota == 'Tomador' || this.$store.state.opNota == 'Não Tomador'){
                    this.objEnviaNotasCte.tag =  this.$store.state.opNota 
                    this.objEnviaNotasNfe.tag =  'DEST'
                }else{
                    this.objEnviaNotasCte.tag = 'Tomador'
                    this.objEnviaNotasNfe.tag =  this.$store.state.opNota 
                }
                if(this.$store.state.opNota == ''){
                    this.objEnviaNotasNfe.tag =  'DEST'
                }
                
                
                this.objEnviaNotas = this.$store.state.tipoNota == 'NFe' ? {"nome":'getNotasV2',"obj":this.objEnviaNotasNfe} :
                 this.$store.state.tipoNota == 'NFCe' ? {"nome":'getNotasNfce',"obj":this.objEnviaNotasNFCe} : 
                  {"nome":'getNotasCte',"obj":this.objEnviaNotasCte} 
                console.log(this.objEnviaNotas)
                let status = await config[this.objEnviaNotas.nome](this.objEnviaNotas.obj)  
                if(status.status >= 400){
                    this.notas = []
                    this.existeNota = false
                    this.notasQuant = 0
                    this.somatoria = 0
                }else{
                    this.existeNota = true
                    this.notas = status.data.lstNotas
                    this.notasQuant = status.data.quantidadeTotal
                    this.somatoria = status.data.valorTotal
                    
                }   
                  
            this.spinerMedio = false
        },          
        nota(tipo){
            this.$store.state.tipoNota = tipo            
            this.zerarParaFiltro()
            this.getNotas() 
            this.allOpNotas = false
            if(this.tipoNota != tipo){
                this.temFiltro = false
            }
            this.tipoNota = tipo   
        },
        async consultar(tipo){
            if(this.$store.state.tipoNota != 'NFCe'){
                this.msgNotasAtulizar= ''
            this.mostraBtnAtulizar = false
            this.allOpConsultar = false
            this.mostraSpinerAtulizar = false
            if(tipo == 'consultar'){
                this.$refs['modalReceita'].show()
                this.mostraSpinerAtulizar = true
                let status = await config.consultaDocumento(this.$store.state.idEmpresa,this.$store.state.tipoNota)   
                if(this.$store.state.tipoNota == 'CTe'){
                     if(status.status>=400){ 
                        this.msgNotasAtulizar = status.data.message
                    }else{
                        if(status.data.lstDocumentos.length == 0){
                            this.msgNotasAtulizar = status.data.mensagem
                        } else{
                             this.mostraBtnAtulizar = true
                        } 
                    }
                    this.mostraSpinerAtulizar = false
                }else{
                    if(status.status>=400){ 
                        this.msgNotasAtulizar = status.data.message
                    }else{
                        this.mostraBtnAtulizar = true
                    }
                    this.mostraSpinerAtulizar = false
                }      
                
            }else{
                if( this.$store.state.tipoNota == 'NFe'){
                    this.$refs['modalImportar'].show()
                }
            }
            }            
        },
        atulizarNotas(){
            this.$refs['modalReceita'].hide()
            this.getNotas()
        },        
    },    
    async created(){  
        this.tipoNota = this.$store.state.tipoNota == 'CTe' ? 'CTe' : this.$store.state.tipoNota == 'NFe' ? 'NFe' : 'NFCe'
        await this.getNotas()     
        this.objEnviaNotasNfe.tag =  'DEST'  
        barramento.$on('sairStatus', async ()=>{
           
            await  this.getNotas()             
         })

         barramento.$on('clickMani', valor=>{
            if(valor){
                this.clickStatus = false
            }else{
                this.clickStatus = true
            }
         })      
         barramento.$on('aplicarFiltro', async (valor,tipo, t, estado)=>{
            console.log(valor,estado)
            this.estado = estado
            this.temFiltro = t
            this.colocarParaFiltrar(valor,tipo)
            this.thisFiltro.hide()  
            await  this.getNotas()             
         })
         
        this.perPage = 1        
    }

}
</script>

<style>
#modalExportar .modal-footer{
    display: none;
}
.clickarquivo {
    width: 100%;
    height: 50px;
    background: #009188;
    margin-bottom: 25px;
    cursor: pointer;
    border-radius: 5px;
}
div.desativado{
    background: rgb(204, 204, 204)  !important;
    cursor: inherit !important;
}
.btnOk{
    padding: 10px;
    width: 100px;
    border: none;
    border-radius: 5px;
    color: #fff;
    background: #009188;
}
.btnOk:focus{
    outline: none;
}
.txtQu{
    text-align: center;
    font-size: 45px;
    color:green;
}
#modalStatus .modal-body{
    padding:0px !important
}
.txtStatus{
    color:#707070;font-weight:bold;font-size:21px;margin-top:20px;text-align: center;
    margin-bottom: 0px;
}
.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #009188;
    border-color: #fff;
}
button.page-link:focus{
    outline: none;
}
.page-link:hover {
    background: #007c74;
    color: #fff;
}
.page-link{
    color:#000;
        padding: .45rem .70rem;
}

.dropzone .dz-preview div.dz-progress{
    height: 20px;
}
div.vue-dropzone {
    border: 1px dashed #707070;
    border-radius: 5px  ;
    max-height: 570px;
    overflow: auto;
}
.vue-dropzone>.dz-preview a.dz-remove {
    position: absolute;
    z-index: 30;
    color: #fff;    
    padding: 2px;
    top: inherit;
    bottom: 15px;
    border: 1px #fff solid;
    text-transform: uppercase;
    font-size: .7rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
}
#modalImportar___BV_modal_title_{
    color: #707070;
    font-weight: bold;
}
.clickarquivo{
    width: 100%;
    height: 50px;
    background: #009188;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;
    cursor: pointer;
    border-radius: 5px;
}
.clickarquivo p{
    color:#fff;
    margin-bottom: 0px;    
    display: flex;
    justify-content: center;
    align-items: center;
}

#modalImportar___BV_modal_footer_{
    display: none;
}
#modalReceita
{
    text-align: center;
}
#modalReceita .btnAtualizar{
    width: 180px;
    font-size: 18px;
    height: 45px;    
    border: none;
    border-radius: 5px;
    color: #fff;
    background: #009188;
}
footer#modalReceita___BV_modal_footer_{
    display: none;
}
footer#modalStatus___BV_modal_footer_{
    display: none;
}
header#modalStatus___BV_modal_header_{
    display: none;
}
.alltxtEmpresa{
    color: #000;
  font-size: 1.8em;
  font-weight: bold;
  margin-top: 40px; 
  text-align: center;
}
.allOpcoes{
    display: flex;
    justify-content: space-around;
    align-content: center;
    padding:0px 0px;
}
.allOpcoes .allCad{
    width: 24%;
    height: 40px;
    position: relative;
    background: #009188;
    color:#fff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
}
.allOpcoes .allCad .allAbl{
    position: absolute;
    left: 10px;
}
.allOpcoes .allCad  .allOpPadrao{
    width: 220px;
    position: absolute;
    color:#009188;
    background: #fff;;
    top:40px;
    box-shadow: 0px 3px 6px #00000029;
    z-index: 3;
}
.allOpcoes .allCad .allOpPadrao p{
    margin: 0px;
    padding: 0px;
    font-size: 12px;
}
.allOpcoes .allCad .allOpPadrao .allAjuste{
    display: flex;
    justify-content: center;
    align-items: center;    
    height: 35px;
}

</style>